module.exports = __webpack_public_path__ + "img/code.5680678b.jpeg";